'use client';
import React from 'react';
import ReactDOM from 'react-dom';

export const Portal: React.FC<React.PropsWithChildren> = ({ children }) => {
  const element = document.createElement('div');

  React.useEffect(() => {
    document.body.appendChild(element);

    return () => {
      document.body.removeChild(element);
    };
  }, [element]);

  return ReactDOM.createPortal(children, element);
};

export default Portal;
